import { LOADING } from './types';

export function toggleLoading(value) {
    return async function(dispatch) {
        dispatch({ type: LOADING, payload: value})
    }
}